import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../../data/faqs';
import { contact } from '../../data/site';
import { Reveal } from '../ui/Reveal';
import { SectionHeader } from '../ui/SectionHeader';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer
      }
    }))
  };
  return <section id="faq" aria-labelledby="faq-title" className="bg-white" data-id="element-239" data-mp="3d2zze69870gl">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schema)
    }} data-id="element-240" data-mp="3d2q8mggcwp9u" />
      <div className="mx-auto grid max-w-page gap-12 px-5 py-20 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16 lg:px-8 lg:py-28" data-id="element-241" data-mp="3i005gh62s37p">
        <Reveal data-id="element-242" data-mp="eczu2rb4k239">
          <div className="lg:sticky lg:top-28" data-id="element-243" data-mp="edjc080ryqha">
            <SectionHeader id="faq-title" title="Questions buyers ask us" intro="Straight answers. If yours isn’t here, an engineer will answer it within 48 hours." data-id="element-244" data-mp="eeavikh3kxr7" />
            <a href={contact.phoneHref} className="mt-6 inline-block text-[15px] font-semibold text-afb-teal underline-offset-4 hover:underline" data-id="element-245" data-mp="1vpsrn2s01eqq">
              Or call {contact.phoneDisplay}
            </a>
          </div>
        </Reveal>

        <Reveal delay={60} data-id="element-246" data-mp="2jfdcxsbmko36">
          <ul className="divide-y divide-afb-line border-y border-afb-line" data-id="element-247" data-mp="2ei526cst3mby">
            {faqs.map((faq, index) => {
            const open = openIndex === index;
            return <li key={faq.question} data-id="element-248" data-mp="2td1fv5jdx1wf" data-mpi={index}>
                  <h3 data-id="element-249" data-mp="2ohcfx13gdizl">
                    <button type="button" id={`faq-button-${index}`} aria-expanded={open} aria-controls={`faq-panel-${index}`} onClick={() => setOpenIndex(open ? null : index)} className="flex w-full items-center justify-between gap-6 py-5 text-left font-sora text-[17px] font-semibold text-afb-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-afb-turquoise" data-id="element-250" data-mp="2ogu9jbn2tody">
                      {faq.question}
                      <PlusIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-afb-ink/60 transition-transform duration-200 ${open ? 'rotate-45' : ''}`} data-id="element-251" data-mp="1xr86b29iz6lh" />
                    </button>
                  </h3>
                  <div id={`faq-panel-${index}`} role="region" aria-labelledby={`faq-button-${index}`} className="collapse-grid" data-open={open} data-id="element-252" data-mp="2bid92d86wf01">
                    <div className="overflow-hidden" data-id="element-253" data-mp="2qfxbpdhm5y31">
                      <p className="max-w-2xl pb-6 text-[15px] leading-relaxed text-afb-muted" data-id="element-254" data-mp="2qchwmanxwp1m">{faq.answer}</p>
                    </div>
                  </div>
                </li>;
          })}
          </ul>
        </Reveal>
      </div>
    </section>;
}